import { DataProductService } from '@/api/services/DataProductService';
import { SearchCollectionGetDataProductListResponseDto } from '@/api';
import store from '@/store';
import authModule from '@/store/modules/auth';
import { getModule } from 'vuex-module-decorators';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const searchDataProductsTool: ToolDefinition = {
  name: 'search_data_products',
  description: 'Search data products. Use for lists, details, health status, asset counts. Returns: id (UUID), name, description, sla, owners (shown as "assignees"), healthSummary, assetCount. Data products use UUID IDs (not URNs). Use get_data_product_by_id for details. Use domainId to filter (default: selected domain).',
  input_schema: {
    type: 'object',
    properties: {
      domainId: {
        type: 'string',
        description: 'Domain ID (UUID). Default: selected domain. Use get_user_domains to get domain IDs.',
      },
    },
    required: [],
  },
};

/**
 * Execute the search_data_products tool
 */
export async function executeSearchDataProducts(params: any): Promise<SearchCollectionGetDataProductListResponseDto | { error: string }> {
  try {
    // Get the auth module to access selected domain
    const auth = getModule(authModule, store);
    const { selectedDomain } = auth;

    // Use provided domainId or fall back to selected domain ID
    const domainId = params.domainId || selectedDomain?.id;

    if (!domainId) {
      return { error: 'Domain ID is required. Please select a domain or provide a domainId parameter.' };
    }

    const result = await callWithContext('sifflet-ai-chat', () => DataProductService.getAllDataProducts({
      domainId,
    }));

    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default searchDataProductsTool;
